//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { environment } from "@environments/environment";
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export class Foo {
  protected getBaseUrl(deaultUrl: string): string {
    return environment.remoteServiceBaseUrl;
  }
}

@Injectable({
    providedIn: 'root'
})
export class AdminEventTypeServiceProxy extends Foo {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateEventInput | undefined): Observable<OwnerCalendarDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminEventType/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OwnerCalendarDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OwnerCalendarDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OwnerCalendarDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OwnerCalendarDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdminEventType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: UpdateEventTypeInput | undefined): Observable<OwnerCalendarDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminEventType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OwnerCalendarDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OwnerCalendarDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OwnerCalendarDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OwnerCalendarDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    migrate(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AdminEventType/Migrate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMigrate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMigrate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processMigrate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param isDeleted (optional) 
     * @param ownerId (optional) 
     * @param ownerName (optional) 
     * @param sort (optional) 
     * @param sortAscending (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, isDeleted: boolean | undefined, ownerId: number | undefined, ownerName: string | undefined, sort: string | undefined, sortAscending: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OwnerCalendarDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminEventType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (isDeleted === null)
            throw new Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined)
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (ownerId === null)
            throw new Error("The parameter 'ownerId' cannot be null.");
        else if (ownerId !== undefined)
            url_ += "OwnerId=" + encodeURIComponent("" + ownerId) + "&";
        if (ownerName === null)
            throw new Error("The parameter 'ownerName' cannot be null.");
        else if (ownerName !== undefined)
            url_ += "OwnerName=" + encodeURIComponent("" + ownerName) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OwnerCalendarDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OwnerCalendarDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OwnerCalendarDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OwnerCalendarDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    get(id: string | undefined): Observable<OwnerCalendarDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminEventType/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OwnerCalendarDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OwnerCalendarDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OwnerCalendarDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OwnerCalendarDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class CalendarAvailability implements ICalendarAvailability {
    individual!: { [key: string]: TimeRange[]; } | undefined;
    weeklyRepeating!: { [key: string]: TimeRange[]; } | undefined;

    constructor(data?: ICalendarAvailability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["individual"]) {
                this.individual = {} as any;
                for (let key in _data["individual"]) {
                    if (_data["individual"].hasOwnProperty(key))
                        (<any>this.individual)![key] = _data["individual"][key] ? _data["individual"][key].map((i: any) => TimeRange.fromJS(i)) : <any>undefined;
                }
            }
            if (_data["weeklyRepeating"]) {
                this.weeklyRepeating = {} as any;
                for (let key in _data["weeklyRepeating"]) {
                    if (_data["weeklyRepeating"].hasOwnProperty(key))
                        (<any>this.weeklyRepeating)![key] = _data["weeklyRepeating"][key] ? _data["weeklyRepeating"][key].map((i: any) => TimeRange.fromJS(i)) : <any>undefined;
                }
            }
        }
    }

    static fromJS(data: any): CalendarAvailability {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarAvailability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.individual) {
            data["individual"] = {};
            for (let key in this.individual) {
                if (this.individual.hasOwnProperty(key))
                    (<any>data["individual"])[key] = (<any>this.individual)[key];
            }
        }
        if (this.weeklyRepeating) {
            data["weeklyRepeating"] = {};
            for (let key in this.weeklyRepeating) {
                if (this.weeklyRepeating.hasOwnProperty(key))
                    (<any>data["weeklyRepeating"])[key] = (<any>this.weeklyRepeating)[key];
            }
        }
        return data;
    }
}

export interface ICalendarAvailability {
    individual: { [key: string]: TimeRange[]; } | undefined;
    weeklyRepeating: { [key: string]: TimeRange[]; } | undefined;
}

export class CalendarOptions implements ICalendarOptions {
    profilePic!: string | undefined;
    meetingLengths!: number[] | undefined;
    availabilityIncrements!: number;
    minimumNoticeMinutes!: number;
    calendarAvailability!: CalendarAvailability;
    description!: string | undefined;
    headline!: string | undefined;
    subline!: string | undefined;
    color!: string | undefined;
    dateRangeType!: string | undefined;
    dateRangeRollingPeriod!: number | undefined;
    dateRangeDateRange!: DateTimeRange;
    location!: string | undefined;
    showLocationBeforeConfirmation!: boolean;
    locationSetting!: LocationSettingEnum;
    guestChoosesLocation!: boolean;
    guestLocationFreeChoice!: boolean;
    guestLocationChoices!: string[] | undefined;
    guestChoosesLocationQuestionText!: string | undefined;
    guestLocationChoicesAllowOther!: boolean;
    guestQuestions!: GuestQuestion[] | undefined;
    reminderEmailSettings!: number[] | undefined;
    maxAttendees!: number;

    constructor(data?: ICalendarOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.calendarAvailability = data.calendarAvailability && !(<any>data.calendarAvailability).toJSON ? new CalendarAvailability(data.calendarAvailability) : <CalendarAvailability>this.calendarAvailability;
            this.dateRangeDateRange = data.dateRangeDateRange && !(<any>data.dateRangeDateRange).toJSON ? new DateTimeRange(data.dateRangeDateRange) : <DateTimeRange>this.dateRangeDateRange;
            if (data.guestQuestions) {
                this.guestQuestions = [];
                for (let i = 0; i < data.guestQuestions.length; i++) {
                    let item = data.guestQuestions[i];
                    this.guestQuestions[i] = item && !(<any>item).toJSON ? new GuestQuestion(item) : <GuestQuestion>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePic = _data["profilePic"];
            if (Array.isArray(_data["meetingLengths"])) {
                this.meetingLengths = [] as any;
                for (let item of _data["meetingLengths"])
                    this.meetingLengths!.push(item);
            }
            this.availabilityIncrements = _data["availabilityIncrements"];
            this.minimumNoticeMinutes = _data["minimumNoticeMinutes"];
            this.calendarAvailability = _data["calendarAvailability"] ? CalendarAvailability.fromJS(_data["calendarAvailability"]) : <any>undefined;
            this.description = _data["description"];
            this.headline = _data["headline"];
            this.subline = _data["subline"];
            this.color = _data["color"];
            this.dateRangeType = _data["dateRangeType"];
            this.dateRangeRollingPeriod = _data["dateRangeRollingPeriod"];
            this.dateRangeDateRange = _data["dateRangeDateRange"] ? DateTimeRange.fromJS(_data["dateRangeDateRange"]) : <any>undefined;
            this.location = _data["location"];
            this.showLocationBeforeConfirmation = _data["showLocationBeforeConfirmation"];
            this.locationSetting = _data["locationSetting"];
            this.guestChoosesLocation = _data["guestChoosesLocation"];
            this.guestLocationFreeChoice = _data["guestLocationFreeChoice"];
            if (Array.isArray(_data["guestLocationChoices"])) {
                this.guestLocationChoices = [] as any;
                for (let item of _data["guestLocationChoices"])
                    this.guestLocationChoices!.push(item);
            }
            this.guestChoosesLocationQuestionText = _data["guestChoosesLocationQuestionText"];
            this.guestLocationChoicesAllowOther = _data["guestLocationChoicesAllowOther"];
            if (Array.isArray(_data["guestQuestions"])) {
                this.guestQuestions = [] as any;
                for (let item of _data["guestQuestions"])
                    this.guestQuestions!.push(GuestQuestion.fromJS(item));
            }
            if (Array.isArray(_data["reminderEmailSettings"])) {
                this.reminderEmailSettings = [] as any;
                for (let item of _data["reminderEmailSettings"])
                    this.reminderEmailSettings!.push(item);
            }
            this.maxAttendees = _data["maxAttendees"];
        }
    }

    static fromJS(data: any): CalendarOptions {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePic"] = this.profilePic;
        if (Array.isArray(this.meetingLengths)) {
            data["meetingLengths"] = [];
            for (let item of this.meetingLengths)
                data["meetingLengths"].push(item);
        }
        data["availabilityIncrements"] = this.availabilityIncrements;
        data["minimumNoticeMinutes"] = this.minimumNoticeMinutes;
        data["calendarAvailability"] = this.calendarAvailability ? this.calendarAvailability.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["headline"] = this.headline;
        data["subline"] = this.subline;
        data["color"] = this.color;
        data["dateRangeType"] = this.dateRangeType;
        data["dateRangeRollingPeriod"] = this.dateRangeRollingPeriod;
        data["dateRangeDateRange"] = this.dateRangeDateRange ? this.dateRangeDateRange.toJSON() : <any>undefined;
        data["location"] = this.location;
        data["showLocationBeforeConfirmation"] = this.showLocationBeforeConfirmation;
        data["locationSetting"] = this.locationSetting;
        data["guestChoosesLocation"] = this.guestChoosesLocation;
        data["guestLocationFreeChoice"] = this.guestLocationFreeChoice;
        if (Array.isArray(this.guestLocationChoices)) {
            data["guestLocationChoices"] = [];
            for (let item of this.guestLocationChoices)
                data["guestLocationChoices"].push(item);
        }
        data["guestChoosesLocationQuestionText"] = this.guestChoosesLocationQuestionText;
        data["guestLocationChoicesAllowOther"] = this.guestLocationChoicesAllowOther;
        if (Array.isArray(this.guestQuestions)) {
            data["guestQuestions"] = [];
            for (let item of this.guestQuestions)
                data["guestQuestions"].push(item.toJSON());
        }
        if (Array.isArray(this.reminderEmailSettings)) {
            data["reminderEmailSettings"] = [];
            for (let item of this.reminderEmailSettings)
                data["reminderEmailSettings"].push(item);
        }
        data["maxAttendees"] = this.maxAttendees;
        return data;
    }
}

export interface ICalendarOptions {
    profilePic: string | undefined;
    meetingLengths: number[] | undefined;
    availabilityIncrements: number;
    minimumNoticeMinutes: number;
    calendarAvailability: ICalendarAvailability;
    description: string | undefined;
    headline: string | undefined;
    subline: string | undefined;
    color: string | undefined;
    dateRangeType: string | undefined;
    dateRangeRollingPeriod: number | undefined;
    dateRangeDateRange: IDateTimeRange;
    location: string | undefined;
    showLocationBeforeConfirmation: boolean;
    locationSetting: LocationSettingEnum;
    guestChoosesLocation: boolean;
    guestLocationFreeChoice: boolean;
    guestLocationChoices: string[] | undefined;
    guestChoosesLocationQuestionText: string | undefined;
    guestLocationChoicesAllowOther: boolean;
    guestQuestions: IGuestQuestion[] | undefined;
    reminderEmailSettings: number[] | undefined;
    maxAttendees: number;
}

export class CalendarOptionsInput implements ICalendarOptionsInput {
    maxAttendees!: number;
    headline!: string | undefined;
    profilePic!: string | undefined;
    description!: string | undefined;
    availabilityIncrements!: number;
    minimumNoticeMinutes!: number;
    color!: string;
    dateRangeType!: string | undefined;
    dateRangeRollingPeriod!: number | undefined;
    dateRangeDateRange!: DateTimeRange;
    reminderEmailSettings!: number[] | undefined;
    subline!: string | undefined;
    locationSetting!: LocationSettingEnum;
    showLocationBeforeConfirmation!: boolean;
    location!: string | undefined;
    guestChoosesLocationQuestionText!: string | undefined;
    guestLocationFreeChoice!: boolean;
    guestLocationChoices!: string[] | undefined;
    guestLocationChoicesAllowOther!: boolean;
    guestQuestions!: GuestQuestion[] | undefined;

    constructor(data?: ICalendarOptionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.dateRangeDateRange = data.dateRangeDateRange && !(<any>data.dateRangeDateRange).toJSON ? new DateTimeRange(data.dateRangeDateRange) : <DateTimeRange>this.dateRangeDateRange;
            if (data.guestQuestions) {
                this.guestQuestions = [];
                for (let i = 0; i < data.guestQuestions.length; i++) {
                    let item = data.guestQuestions[i];
                    this.guestQuestions[i] = item && !(<any>item).toJSON ? new GuestQuestion(item) : <GuestQuestion>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxAttendees = _data["maxAttendees"];
            this.headline = _data["headline"];
            this.profilePic = _data["profilePic"];
            this.description = _data["description"];
            this.availabilityIncrements = _data["availabilityIncrements"];
            this.minimumNoticeMinutes = _data["minimumNoticeMinutes"];
            this.color = _data["color"];
            this.dateRangeType = _data["dateRangeType"];
            this.dateRangeRollingPeriod = _data["dateRangeRollingPeriod"];
            this.dateRangeDateRange = _data["dateRangeDateRange"] ? DateTimeRange.fromJS(_data["dateRangeDateRange"]) : <any>undefined;
            if (Array.isArray(_data["reminderEmailSettings"])) {
                this.reminderEmailSettings = [] as any;
                for (let item of _data["reminderEmailSettings"])
                    this.reminderEmailSettings!.push(item);
            }
            this.subline = _data["subline"];
            this.locationSetting = _data["locationSetting"];
            this.showLocationBeforeConfirmation = _data["showLocationBeforeConfirmation"];
            this.location = _data["location"];
            this.guestChoosesLocationQuestionText = _data["guestChoosesLocationQuestionText"];
            this.guestLocationFreeChoice = _data["guestLocationFreeChoice"];
            if (Array.isArray(_data["guestLocationChoices"])) {
                this.guestLocationChoices = [] as any;
                for (let item of _data["guestLocationChoices"])
                    this.guestLocationChoices!.push(item);
            }
            this.guestLocationChoicesAllowOther = _data["guestLocationChoicesAllowOther"];
            if (Array.isArray(_data["guestQuestions"])) {
                this.guestQuestions = [] as any;
                for (let item of _data["guestQuestions"])
                    this.guestQuestions!.push(GuestQuestion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalendarOptionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarOptionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxAttendees"] = this.maxAttendees;
        data["headline"] = this.headline;
        data["profilePic"] = this.profilePic;
        data["description"] = this.description;
        data["availabilityIncrements"] = this.availabilityIncrements;
        data["minimumNoticeMinutes"] = this.minimumNoticeMinutes;
        data["color"] = this.color;
        data["dateRangeType"] = this.dateRangeType;
        data["dateRangeRollingPeriod"] = this.dateRangeRollingPeriod;
        data["dateRangeDateRange"] = this.dateRangeDateRange ? this.dateRangeDateRange.toJSON() : <any>undefined;
        if (Array.isArray(this.reminderEmailSettings)) {
            data["reminderEmailSettings"] = [];
            for (let item of this.reminderEmailSettings)
                data["reminderEmailSettings"].push(item);
        }
        data["subline"] = this.subline;
        data["locationSetting"] = this.locationSetting;
        data["showLocationBeforeConfirmation"] = this.showLocationBeforeConfirmation;
        data["location"] = this.location;
        data["guestChoosesLocationQuestionText"] = this.guestChoosesLocationQuestionText;
        data["guestLocationFreeChoice"] = this.guestLocationFreeChoice;
        if (Array.isArray(this.guestLocationChoices)) {
            data["guestLocationChoices"] = [];
            for (let item of this.guestLocationChoices)
                data["guestLocationChoices"].push(item);
        }
        data["guestLocationChoicesAllowOther"] = this.guestLocationChoicesAllowOther;
        if (Array.isArray(this.guestQuestions)) {
            data["guestQuestions"] = [];
            for (let item of this.guestQuestions)
                data["guestQuestions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICalendarOptionsInput {
    maxAttendees: number;
    headline: string | undefined;
    profilePic: string | undefined;
    description: string | undefined;
    availabilityIncrements: number;
    minimumNoticeMinutes: number;
    color: string;
    dateRangeType: string | undefined;
    dateRangeRollingPeriod: number | undefined;
    dateRangeDateRange: IDateTimeRange;
    reminderEmailSettings: number[] | undefined;
    subline: string | undefined;
    locationSetting: LocationSettingEnum;
    showLocationBeforeConfirmation: boolean;
    location: string | undefined;
    guestChoosesLocationQuestionText: string | undefined;
    guestLocationFreeChoice: boolean;
    guestLocationChoices: string[] | undefined;
    guestLocationChoicesAllowOther: boolean;
    guestQuestions: IGuestQuestion[] | undefined;
}

export class CreateEventInput implements ICreateEventInput {
    id!: string | undefined;
    name!: string;
    url!: string;
    isActive!: boolean;
    eventTypeHosts!: EventTypeHostBase[] | undefined;
    durationPackages!: DurationPackageInput[];
    organizerId!: number;
    groupLeaderUserId!: number;
    paymentCurrency!: string | undefined;
    paymentAccountId!: string | undefined;
    paymentTerms!: string | undefined;
    calendarOptions!: CalendarOptionsInput;
    eventType!: EventTypes;
    startBufferMinutes!: number;
    endBufferMinutes!: number;
    userId!: number;

    constructor(data?: ICreateEventInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.eventTypeHosts) {
                this.eventTypeHosts = [];
                for (let i = 0; i < data.eventTypeHosts.length; i++) {
                    let item = data.eventTypeHosts[i];
                    this.eventTypeHosts[i] = item && !(<any>item).toJSON ? new EventTypeHostBase(item) : <EventTypeHostBase>item;
                }
            }
            if (data.durationPackages) {
                this.durationPackages = [];
                for (let i = 0; i < data.durationPackages.length; i++) {
                    let item = data.durationPackages[i];
                    this.durationPackages[i] = item && !(<any>item).toJSON ? new DurationPackageInput(item) : <DurationPackageInput>item;
                }
            }
            this.calendarOptions = data.calendarOptions && !(<any>data.calendarOptions).toJSON ? new CalendarOptionsInput(data.calendarOptions) : <CalendarOptionsInput>this.calendarOptions;
        }
        if (!data) {
            this.durationPackages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["eventTypeHosts"])) {
                this.eventTypeHosts = [] as any;
                for (let item of _data["eventTypeHosts"])
                    this.eventTypeHosts!.push(EventTypeHostBase.fromJS(item));
            }
            if (Array.isArray(_data["durationPackages"])) {
                this.durationPackages = [] as any;
                for (let item of _data["durationPackages"])
                    this.durationPackages!.push(DurationPackageInput.fromJS(item));
            }
            this.organizerId = _data["organizerId"];
            this.groupLeaderUserId = _data["groupLeaderUserId"];
            this.paymentCurrency = _data["paymentCurrency"];
            this.paymentAccountId = _data["paymentAccountId"];
            this.paymentTerms = _data["paymentTerms"];
            this.calendarOptions = _data["calendarOptions"] ? CalendarOptionsInput.fromJS(_data["calendarOptions"]) : <any>undefined;
            this.eventType = _data["eventType"];
            this.startBufferMinutes = _data["startBufferMinutes"];
            this.endBufferMinutes = _data["endBufferMinutes"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): CreateEventInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEventInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.eventTypeHosts)) {
            data["eventTypeHosts"] = [];
            for (let item of this.eventTypeHosts)
                data["eventTypeHosts"].push(item.toJSON());
        }
        if (Array.isArray(this.durationPackages)) {
            data["durationPackages"] = [];
            for (let item of this.durationPackages)
                data["durationPackages"].push(item.toJSON());
        }
        data["organizerId"] = this.organizerId;
        data["groupLeaderUserId"] = this.groupLeaderUserId;
        data["paymentCurrency"] = this.paymentCurrency;
        data["paymentAccountId"] = this.paymentAccountId;
        data["paymentTerms"] = this.paymentTerms;
        data["calendarOptions"] = this.calendarOptions ? this.calendarOptions.toJSON() : <any>undefined;
        data["eventType"] = this.eventType;
        data["startBufferMinutes"] = this.startBufferMinutes;
        data["endBufferMinutes"] = this.endBufferMinutes;
        data["userId"] = this.userId;
        return data;
    }
}

export interface ICreateEventInput {
    id: string | undefined;
    name: string;
    url: string;
    isActive: boolean;
    eventTypeHosts: IEventTypeHostBase[] | undefined;
    durationPackages: IDurationPackageInput[];
    organizerId: number;
    groupLeaderUserId: number;
    paymentCurrency: string | undefined;
    paymentAccountId: string | undefined;
    paymentTerms: string | undefined;
    calendarOptions: ICalendarOptionsInput;
    eventType: EventTypes;
    startBufferMinutes: number;
    endBufferMinutes: number;
    userId: number;
}

export class DateTimeRange implements IDateTimeRange {
    startTime!: Date;
    endTime!: Date;

    constructor(data?: IDateTimeRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DateTimeRange {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDateTimeRange {
    startTime: Date;
    endTime: Date;
}

export class DurationPackageDto implements IDurationPackageDto {
    id!: string;
    minutes!: number;
    paymentAmount!: number;

    constructor(data?: IDurationPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.minutes = _data["minutes"];
            this.paymentAmount = _data["paymentAmount"];
        }
    }

    static fromJS(data: any): DurationPackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new DurationPackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["minutes"] = this.minutes;
        data["paymentAmount"] = this.paymentAmount;
        return data;
    }
}

export interface IDurationPackageDto {
    id: string;
    minutes: number;
    paymentAmount: number;
}

export class DurationPackageInput implements IDurationPackageInput {
    minutes!: number;
    paymentAmount!: number;

    constructor(data?: IDurationPackageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minutes = _data["minutes"];
            this.paymentAmount = _data["paymentAmount"];
        }
    }

    static fromJS(data: any): DurationPackageInput {
        data = typeof data === 'object' ? data : {};
        let result = new DurationPackageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minutes"] = this.minutes;
        data["paymentAmount"] = this.paymentAmount;
        return data;
    }
}

export interface IDurationPackageInput {
    minutes: number;
    paymentAmount: number;
}

export class EventTypeHostBase implements IEventTypeHostBase {
    userId!: number;
    order!: number;
    useDefaultAvailability!: boolean;
    calendarAvailability!: CalendarAvailability;
    location!: string | undefined;
    locationType!: LocationType;

    constructor(data?: IEventTypeHostBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.calendarAvailability = data.calendarAvailability && !(<any>data.calendarAvailability).toJSON ? new CalendarAvailability(data.calendarAvailability) : <CalendarAvailability>this.calendarAvailability;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.order = _data["order"];
            this.useDefaultAvailability = _data["useDefaultAvailability"];
            this.calendarAvailability = _data["calendarAvailability"] ? CalendarAvailability.fromJS(_data["calendarAvailability"]) : <any>undefined;
            this.location = _data["location"];
            this.locationType = _data["locationType"];
        }
    }

    static fromJS(data: any): EventTypeHostBase {
        data = typeof data === 'object' ? data : {};
        let result = new EventTypeHostBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["order"] = this.order;
        data["useDefaultAvailability"] = this.useDefaultAvailability;
        data["calendarAvailability"] = this.calendarAvailability ? this.calendarAvailability.toJSON() : <any>undefined;
        data["location"] = this.location;
        data["locationType"] = this.locationType;
        return data;
    }
}

export interface IEventTypeHostBase {
    userId: number;
    order: number;
    useDefaultAvailability: boolean;
    calendarAvailability: ICalendarAvailability;
    location: string | undefined;
    locationType: LocationType;
}

export class EventTypeHostDto implements IEventTypeHostDto {
    userId!: number;
    order!: number;
    useDefaultAvailability!: boolean;
    calendarAvailability!: CalendarAvailability;
    location!: string | undefined;
    locationType!: LocationType;
    user!: HostUserDto;

    constructor(data?: IEventTypeHostDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.calendarAvailability = data.calendarAvailability && !(<any>data.calendarAvailability).toJSON ? new CalendarAvailability(data.calendarAvailability) : <CalendarAvailability>this.calendarAvailability;
            this.user = data.user && !(<any>data.user).toJSON ? new HostUserDto(data.user) : <HostUserDto>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.order = _data["order"];
            this.useDefaultAvailability = _data["useDefaultAvailability"];
            this.calendarAvailability = _data["calendarAvailability"] ? CalendarAvailability.fromJS(_data["calendarAvailability"]) : <any>undefined;
            this.location = _data["location"];
            this.locationType = _data["locationType"];
            this.user = _data["user"] ? HostUserDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EventTypeHostDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventTypeHostDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["order"] = this.order;
        data["useDefaultAvailability"] = this.useDefaultAvailability;
        data["calendarAvailability"] = this.calendarAvailability ? this.calendarAvailability.toJSON() : <any>undefined;
        data["location"] = this.location;
        data["locationType"] = this.locationType;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEventTypeHostDto {
    userId: number;
    order: number;
    useDefaultAvailability: boolean;
    calendarAvailability: ICalendarAvailability;
    location: string | undefined;
    locationType: LocationType;
    user: IHostUserDto;
}

export enum EventTypes {
    _0 = 0,
    _1 = 1,
}

export class GuestQuestion implements IGuestQuestion {
    enabled!: boolean;
    required!: boolean;
    question!: string;
    answerType!: string;
    choices!: string[] | undefined;
    freeChoice!: boolean | undefined;

    constructor(data?: IGuestQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.required = _data["required"];
            this.question = _data["question"];
            this.answerType = _data["answerType"];
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(item);
            }
            this.freeChoice = _data["freeChoice"];
        }
    }

    static fromJS(data: any): GuestQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new GuestQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["required"] = this.required;
        data["question"] = this.question;
        data["answerType"] = this.answerType;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item);
        }
        data["freeChoice"] = this.freeChoice;
        return data;
    }
}

export interface IGuestQuestion {
    enabled: boolean;
    required: boolean;
    question: string;
    answerType: string;
    choices: string[] | undefined;
    freeChoice: boolean | undefined;
}

export class HostUserDto implements IHostUserDto {
    id!: number;
    userName!: string;
    name!: string;
    surname!: string;
    companyName!: string | undefined;
    emailAddress!: string;
    fullName!: string | undefined;
    timezone!: string | undefined;

    constructor(data?: IHostUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.companyName = _data["companyName"];
            this.emailAddress = _data["emailAddress"];
            this.fullName = _data["fullName"];
            this.timezone = _data["timezone"];
        }
    }

    static fromJS(data: any): HostUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["companyName"] = this.companyName;
        data["emailAddress"] = this.emailAddress;
        data["fullName"] = this.fullName;
        data["timezone"] = this.timezone;
        return data;
    }
}

export interface IHostUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string;
    companyName: string | undefined;
    emailAddress: string;
    fullName: string | undefined;
    timezone: string | undefined;
}

export enum LocationSettingEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum LocationType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class OwnerCalendarDto implements IOwnerCalendarDto {
    id!: string;
    name!: string | undefined;
    url!: string | undefined;
    calendarOptions!: CalendarOptions;
    isActive!: boolean;
    isDeleted!: boolean;
    ownerId!: number;
    ownerFullName!: string | undefined;
    eventTypeHosts!: EventTypeHostDto[] | undefined;
    paymentAccount!: PaymentAccountDto;
    paymentTerms!: string | undefined;
    durationPackages!: DurationPackageDto[] | undefined;
    paymentCurrency!: string | undefined;
    organizerId!: number | undefined;
    startBufferMinutes!: number;
    endBufferMinutes!: number;
    eventType!: EventTypes;
    groupLeaderUserId!: number | undefined;

    constructor(data?: IOwnerCalendarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.calendarOptions = data.calendarOptions && !(<any>data.calendarOptions).toJSON ? new CalendarOptions(data.calendarOptions) : <CalendarOptions>this.calendarOptions;
            if (data.eventTypeHosts) {
                this.eventTypeHosts = [];
                for (let i = 0; i < data.eventTypeHosts.length; i++) {
                    let item = data.eventTypeHosts[i];
                    this.eventTypeHosts[i] = item && !(<any>item).toJSON ? new EventTypeHostDto(item) : <EventTypeHostDto>item;
                }
            }
            this.paymentAccount = data.paymentAccount && !(<any>data.paymentAccount).toJSON ? new PaymentAccountDto(data.paymentAccount) : <PaymentAccountDto>this.paymentAccount;
            if (data.durationPackages) {
                this.durationPackages = [];
                for (let i = 0; i < data.durationPackages.length; i++) {
                    let item = data.durationPackages[i];
                    this.durationPackages[i] = item && !(<any>item).toJSON ? new DurationPackageDto(item) : <DurationPackageDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.calendarOptions = _data["calendarOptions"] ? CalendarOptions.fromJS(_data["calendarOptions"]) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.ownerId = _data["ownerId"];
            this.ownerFullName = _data["ownerFullName"];
            if (Array.isArray(_data["eventTypeHosts"])) {
                this.eventTypeHosts = [] as any;
                for (let item of _data["eventTypeHosts"])
                    this.eventTypeHosts!.push(EventTypeHostDto.fromJS(item));
            }
            this.paymentAccount = _data["paymentAccount"] ? PaymentAccountDto.fromJS(_data["paymentAccount"]) : <any>undefined;
            this.paymentTerms = _data["paymentTerms"];
            if (Array.isArray(_data["durationPackages"])) {
                this.durationPackages = [] as any;
                for (let item of _data["durationPackages"])
                    this.durationPackages!.push(DurationPackageDto.fromJS(item));
            }
            this.paymentCurrency = _data["paymentCurrency"];
            this.organizerId = _data["organizerId"];
            this.startBufferMinutes = _data["startBufferMinutes"];
            this.endBufferMinutes = _data["endBufferMinutes"];
            this.eventType = _data["eventType"];
            this.groupLeaderUserId = _data["groupLeaderUserId"];
        }
    }

    static fromJS(data: any): OwnerCalendarDto {
        data = typeof data === 'object' ? data : {};
        let result = new OwnerCalendarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        data["calendarOptions"] = this.calendarOptions ? this.calendarOptions.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["ownerId"] = this.ownerId;
        data["ownerFullName"] = this.ownerFullName;
        if (Array.isArray(this.eventTypeHosts)) {
            data["eventTypeHosts"] = [];
            for (let item of this.eventTypeHosts)
                data["eventTypeHosts"].push(item.toJSON());
        }
        data["paymentAccount"] = this.paymentAccount ? this.paymentAccount.toJSON() : <any>undefined;
        data["paymentTerms"] = this.paymentTerms;
        if (Array.isArray(this.durationPackages)) {
            data["durationPackages"] = [];
            for (let item of this.durationPackages)
                data["durationPackages"].push(item.toJSON());
        }
        data["paymentCurrency"] = this.paymentCurrency;
        data["organizerId"] = this.organizerId;
        data["startBufferMinutes"] = this.startBufferMinutes;
        data["endBufferMinutes"] = this.endBufferMinutes;
        data["eventType"] = this.eventType;
        data["groupLeaderUserId"] = this.groupLeaderUserId;
        return data;
    }
}

export interface IOwnerCalendarDto {
    id: string;
    name: string | undefined;
    url: string | undefined;
    calendarOptions: ICalendarOptions;
    isActive: boolean;
    isDeleted: boolean;
    ownerId: number;
    ownerFullName: string | undefined;
    eventTypeHosts: IEventTypeHostDto[] | undefined;
    paymentAccount: IPaymentAccountDto;
    paymentTerms: string | undefined;
    durationPackages: IDurationPackageDto[] | undefined;
    paymentCurrency: string | undefined;
    organizerId: number | undefined;
    startBufferMinutes: number;
    endBufferMinutes: number;
    eventType: EventTypes;
    groupLeaderUserId: number | undefined;
}

export class OwnerCalendarDtoPagedResultDto implements IOwnerCalendarDtoPagedResultDto {
    items!: OwnerCalendarDto[] | undefined;
    totalCount!: number;

    constructor(data?: IOwnerCalendarDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new OwnerCalendarDto(item) : <OwnerCalendarDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OwnerCalendarDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): OwnerCalendarDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OwnerCalendarDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IOwnerCalendarDtoPagedResultDto {
    items: IOwnerCalendarDto[] | undefined;
    totalCount: number;
}

export class PaymentAccountDto implements IPaymentAccountDto {
    id!: string;
    externalId!: string | undefined;
    isActive!: boolean;
    name!: string | undefined;

    constructor(data?: IPaymentAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalId = _data["externalId"];
            this.isActive = _data["isActive"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PaymentAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalId"] = this.externalId;
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        return data;
    }
}

export interface IPaymentAccountDto {
    id: string;
    externalId: string | undefined;
    isActive: boolean;
    name: string | undefined;
}

export class Time implements ITime {
    hours!: number;
    minutes!: number;

    constructor(data?: ITime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hours = _data["hours"];
            this.minutes = _data["minutes"];
        }
    }

    static fromJS(data: any): Time {
        data = typeof data === 'object' ? data : {};
        let result = new Time();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hours"] = this.hours;
        data["minutes"] = this.minutes;
        return data;
    }
}

export interface ITime {
    hours: number;
    minutes: number;
}

export class TimeRange implements ITimeRange {
    start!: Time;
    end!: Time;

    constructor(data?: ITimeRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.start = data.start && !(<any>data.start).toJSON ? new Time(data.start) : <Time>this.start;
            this.end = data.end && !(<any>data.end).toJSON ? new Time(data.end) : <Time>this.end;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? Time.fromJS(_data["start"]) : <any>undefined;
            this.end = _data["end"] ? Time.fromJS(_data["end"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeRange {
        data = typeof data === 'object' ? data : {};
        let result = new TimeRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toJSON() : <any>undefined;
        data["end"] = this.end ? this.end.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITimeRange {
    start: ITime;
    end: ITime;
}

export class UpdateEventTypeInput implements IUpdateEventTypeInput {
    id!: string;
    name!: string;
    url!: string;
    isActive!: boolean;
    eventTypeHosts!: EventTypeHostBase[] | undefined;
    durationPackages!: DurationPackageInput[];
    organizerId!: number;
    groupLeaderUserId!: number;
    paymentCurrency!: string | undefined;
    paymentAccountId!: string | undefined;
    paymentTerms!: string | undefined;
    calendarOptions!: CalendarOptionsInput;
    eventType!: EventTypes;
    startBufferMinutes!: number;
    endBufferMinutes!: number;

    constructor(data?: IUpdateEventTypeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.eventTypeHosts) {
                this.eventTypeHosts = [];
                for (let i = 0; i < data.eventTypeHosts.length; i++) {
                    let item = data.eventTypeHosts[i];
                    this.eventTypeHosts[i] = item && !(<any>item).toJSON ? new EventTypeHostBase(item) : <EventTypeHostBase>item;
                }
            }
            if (data.durationPackages) {
                this.durationPackages = [];
                for (let i = 0; i < data.durationPackages.length; i++) {
                    let item = data.durationPackages[i];
                    this.durationPackages[i] = item && !(<any>item).toJSON ? new DurationPackageInput(item) : <DurationPackageInput>item;
                }
            }
            this.calendarOptions = data.calendarOptions && !(<any>data.calendarOptions).toJSON ? new CalendarOptionsInput(data.calendarOptions) : <CalendarOptionsInput>this.calendarOptions;
        }
        if (!data) {
            this.durationPackages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["eventTypeHosts"])) {
                this.eventTypeHosts = [] as any;
                for (let item of _data["eventTypeHosts"])
                    this.eventTypeHosts!.push(EventTypeHostBase.fromJS(item));
            }
            if (Array.isArray(_data["durationPackages"])) {
                this.durationPackages = [] as any;
                for (let item of _data["durationPackages"])
                    this.durationPackages!.push(DurationPackageInput.fromJS(item));
            }
            this.organizerId = _data["organizerId"];
            this.groupLeaderUserId = _data["groupLeaderUserId"];
            this.paymentCurrency = _data["paymentCurrency"];
            this.paymentAccountId = _data["paymentAccountId"];
            this.paymentTerms = _data["paymentTerms"];
            this.calendarOptions = _data["calendarOptions"] ? CalendarOptionsInput.fromJS(_data["calendarOptions"]) : <any>undefined;
            this.eventType = _data["eventType"];
            this.startBufferMinutes = _data["startBufferMinutes"];
            this.endBufferMinutes = _data["endBufferMinutes"];
        }
    }

    static fromJS(data: any): UpdateEventTypeInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEventTypeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.eventTypeHosts)) {
            data["eventTypeHosts"] = [];
            for (let item of this.eventTypeHosts)
                data["eventTypeHosts"].push(item.toJSON());
        }
        if (Array.isArray(this.durationPackages)) {
            data["durationPackages"] = [];
            for (let item of this.durationPackages)
                data["durationPackages"].push(item.toJSON());
        }
        data["organizerId"] = this.organizerId;
        data["groupLeaderUserId"] = this.groupLeaderUserId;
        data["paymentCurrency"] = this.paymentCurrency;
        data["paymentAccountId"] = this.paymentAccountId;
        data["paymentTerms"] = this.paymentTerms;
        data["calendarOptions"] = this.calendarOptions ? this.calendarOptions.toJSON() : <any>undefined;
        data["eventType"] = this.eventType;
        data["startBufferMinutes"] = this.startBufferMinutes;
        data["endBufferMinutes"] = this.endBufferMinutes;
        return data;
    }
}

export interface IUpdateEventTypeInput {
    id: string;
    name: string;
    url: string;
    isActive: boolean;
    eventTypeHosts: IEventTypeHostBase[] | undefined;
    durationPackages: IDurationPackageInput[];
    organizerId: number;
    groupLeaderUserId: number;
    paymentCurrency: string | undefined;
    paymentAccountId: string | undefined;
    paymentTerms: string | undefined;
    calendarOptions: ICalendarOptionsInput;
    eventType: EventTypes;
    startBufferMinutes: number;
    endBufferMinutes: number;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}